import React, { Component } from "react";
import dayjs from "dayjs";
import { withRouter } from "react-router-dom";
import Calendar from "react-calendar";
import { Icon } from "antd";
import numeral from "numeral";
// import Calendar from "react-calendar/dist/entry.nostyle";
import _ from "lodash";
import { Button, ClickOutSilde, Slider } from "../../components";
import { withRedux } from "../../hoc";

import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
dayjs.extend(isSameOrAfter);

const createArrowButton = (direction) => {
  return (props) => {
    const { className, style, onClick } = props;
    return (
      <Button className={className} style={style} onClick={onClick}>
        {direction === "left" ? (
          <i className="fa fa-arrow-left" />
        ) : (
          <i className="fa fa-arrow-right" />
        )}
      </Button>
    );
  };
};

const NextButton = createArrowButton("right");
const PrevButton = createArrowButton("left");

const mapStateToProps = ({ language, t, auth }) => {
  return {
    language,
    t,
    isLogin: _.get(auth, "isLogin"),
    agentName: _.get(auth, "data.profile.senate_AgentName"),
    balance: _.toNumber(_.get(auth, "data.balance")),
  };
};

@withRouter
@withRedux(mapStateToProps)
export default class BookingStep1 extends Component {
  constructor(props) {
    super(props);
    this.slider = React.createRef();
  }
  state = {
    openCalendar: false,
    days: [],
  };

  componentDidMount = () => {
    this.init();
  };
  componentDidUpdate(prevProps) {
    if (prevProps.selectedDate !== this.props.selectedDate) {
      this.init();
    }
  }
  init = () => {
    this.getDays();
  };
  getDays = () => {
    const distanceDays = 60;

    const prevDays = _.compact(
      _.map(_.reverse(_.times(distanceDays)), (day) => {
        const prevDay = dayjs(this.props.selectedDate).subtract(day, "day");
        if (dayjs(prevDay).isBefore(dayjs(), "day")) {
          return null;
        }
        return prevDay;
      })
    );

    const nextDays = _.map(_.times(distanceDays), (day) => {
      return dayjs(this.props.selectedDate).add(day + 1, "day");
    });

    const days = [...prevDays, ...nextDays];

    this.setState({
      days,
    });
  };
  handleChangeDate = (value) => {
    if (this.state.openCalendar) {
      this.setState({ openCalendar: false });
    }
    this.props.onClickDate(value);
  };
  handleClickOutSideCalendar = () => {
    this.setState({
      openCalendar: false,
    });
  };
  handleClickTime = (showTimeID) => {
    this.props.onClickShowTime(showTimeID);
  };
  handleClickShowCalendar = () => {
    this.setState({
      openCalendar: true,
    });
  };
  handleClickNext = () => {
    const { selectedDate, selectedShowtimeId } = this.props;
    this.props.onClickNext(selectedDate, selectedShowtimeId);
  };
  render() {
    const {
      selectedDate,
      selectedShowtimeId,
      showtimes,
      loadingShowtimes,
      loadedShowtimes,
      t,
      language,
      isLogin,
      agentName,
      balance,
    } = this.props;
    const { openCalendar, days } = this.state;

    const today = dayjs();

    const currentDay = dayjs(selectedDate).format("D");
    const isToday = dayjs(selectedDate).isSame(today, "day");
    const textBalance = numeral(balance).format("0,0");
    const formatDay = dayjs(selectedDate).format("dddd");
    const isSameAfter = dayjs(selectedDate).isSameOrAfter(dayjs("2022/11/28"));
    const offDay =
      _.toLower(formatDay) === "monday" || _.toLower(formatDay) === "tuesday";

    return (
      <div className="booking-step-1">
        <div className="container-title-bar">
          <h2>{t("Select Date & Showtime")}</h2>
          <div className="right-block">
            {isLogin && (
              <div className="agent-block">
                <p>
                  <span className="bold">{t("Agent")}:</span> {agentName}
                </p>
                {balance > 0 && (
                  <p className="p-credit">
                    <span className="bold">{t("Credit Remain")}:</span>{" "}
                    {textBalance} {t("THB")}
                  </p>
                )}
              </div>
            )}
            <Button
              className="calendar-button"
              ghost
              bordercolor="#ffbd00"
              onClick={this.handleClickShowCalendar}
            >
              {t("Show Calendar")} <Icon type="calendar" />
            </Button>
          </div>
          <div className="calendar-block">
            {openCalendar && (
              <ClickOutSilde onClickOutSide={this.handleClickOutSideCalendar}>
                <Calendar
                  onChange={(value) => {
                    this.handleChangeDate(value);

                    setTimeout(() => {
                      const selectedDay = dayjs(this.props.selectedDate);
                      const dayIndex = _.findIndex(this.state.days, (d) => {
                        return dayjs(d).isSame(selectedDay, "day");
                      });
                      this.slider.current.slickGoTo(dayIndex);
                    }, 1);
                  }}
                  showNeighboringMonth={false}
                  value={new Date()}
                  minDate={new Date()}
                />
              </ClickOutSilde>
            )}
          </div>
        </div>
        <div className="container-calendar">
          <Slider
            sliderRef={this.slider}
            items={days}
            settings={{
              dots: false,
              arrows: true,
              infinite: false,
              nextArrow: <NextButton />,
              prevArrow: <PrevButton />,
              slidesToShow: 7,
              slidesToScroll: 2,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 6,
                  },
                },
                {
                  breakpoint: 760,
                  settings: {
                    slidesToShow: 3,
                  },
                },
              ],
            }}
            uiRenderer={(item, key) => {
              const day = item.format("D");
              const dayName = item.format("ddd");
              return (
                <div
                  className={`date-block ${
                    currentDay === day ? "selected" : ""
                  }`}
                  key={item.format()}
                  onClick={() => this.handleChangeDate(item)}
                >
                  <p className="day-name">{dayName}</p>
                  <h2>{day}</h2>
                  <p>
                    {item.format("MMM")}
                    <br />
                    {item.format("YYYY")}
                  </p>
                </div>
              );
            }}
          />
        </div>
        <p className="description">- {t("Please select Showtime")} -</p>
        {loadingShowtimes ? (
          <div style={{ textAlign: "center", color: "#ffffff" }}>
            {t("Loading")}...
          </div>
        ) : (
          <div className="container-showtimes">
            {_.map(showtimes, (item, index) => {
              const showTimeID = _.get(item, "showTimeID");
              const availableSeats = _.get(item, "available");
              const time = dayjs(_.get(item, "showTime")).format("HH:mm");
              const currentTime = dayjs().format("HH:mm");
              let isPassed = false;
              if (isToday) {
                isPassed = currentTime >= time;
              }
              const active = showTimeID === selectedShowtimeId;
              let wordShow = `${availableSeats} ${t("Seats Available")}`;
              if (language.currentActive === "cn") {
                wordShow = `可选座位数 ${availableSeats}`;
              } else if (language.currentActive === "th") {
                wordShow = `เหลือเพียง ${availableSeats} ที่นั่ง`;
              }

              const isOffDay = offDay
                ? t("Off Day")
                : t("Please click 'Live Chat' to chat with our agent.");
              const isAvailableSeats = availableSeats < 100 ? wordShow : "";
              const isAfter = isSameAfter
                ? t("Please click 'Live Chat' to chat with our agent.")
                : isOffDay;

              const xxx = availableSeats < 1 ? isAfter : isAvailableSeats;

              return (
                <div
                  className={`showtime-block ${
                    active ? "current-showtime" : ""
                  } ${availableSeats < 1 ? "empty" : ""} ${
                    isPassed ? "passed-time" : ""
                  }`}
                  key={index}
                  onClick={() => this.handleClickTime(showTimeID)}
                >
                  <h3>{time}</h3>
                  <p
                    className="seat-number"
                    style={{ display: availableSeats < 100 ? "block" : "none" }}
                  >
                    {/* {availableSeats < 1
                      ? offDay
                        ? t("Off Day")
                        : t("Please click 'Live Chat' to chat with our agent.")
                      : availableSeats < 100
                      ? wordShow
                      : ""} */}
                    {xxx}
                  </p>
                </div>
              );
            })}
          </div>
        )}
        <div className="container-button">
          <Button
            className="large"
            type="primary"
            onClick={this.handleClickNext}
            disabled={!loadedShowtimes || !selectedDate || !selectedShowtimeId}
          >
            {t("Next Step")}
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Booking/BookingStep1.js